import { Button } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import React from "react";

export const HoldStatus: React.FC<{
  hold: HostSystemItemView;
  onClickSuspend: () => void;
}> = ({ hold, onClickSuspend }) => {
  const { translate } = useLanguage();
  return (
    <span className="holdStatus">
      {hold.suspendUntilDate && (
        <>
          <span>{translate("status")}:</span>{" "}
          <strong className="suspended">{translate("suspended")}</strong>{" "}
          <span className="pickupDate">{translate("until")}:</span>{" "}
          <strong className="pickupDate">
            {hold.suspendUntilDateString}
            <Button onClick={onClickSuspend}>({translate("change")})</Button>
          </strong>
        </>
      )}
      {!hold.suspendUntilDate && (
        <>
          {hold.status === "AR" && (
            <>
              {translate("status")}:{" "}
              <span className="arrived">{translate("arrived")}</span>
            </>
          )}
          {hold.status === "T" && (
            <>
              {translate("status")}:{" "}
              <span className="inTransit">{translate("inTransit")}</span>
            </>
          )}
          {hold.status === "PE" && (
            <>
              {translate("positionInQueue")}:{" "}
              <span className="queueLength">{hold.holdQueueLength}</span>
            </>
          )}
        </>
      )}
    </span>
  );
};
